import React, { useEffect, useState } from 'react';
import { Table, Spinner, Alert, Container } from 'react-bootstrap';
import {
  FaStore,
  FaDollarSign,
  FaBoxes,
  FaCalendarAlt,
  FaUser,
  FaClock,
  FaMoneyBillWave,
} from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import XGolifeDashboardComponent from './components/XGolifeDashboardComponent';
import emptyImage from '../../src/assets/img/undraw_posting_photo.svg';
import { API_URL } from "../config";

const SalesByBranch = () => {
  const [salesData, setSalesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSalesData = async () => {
      const companyId = localStorage.getItem('company_id');
      const branchId = localStorage.getItem('branch_id');

      try {
        const response = await fetch(
          `http://localhost:3009/salepostrans/getallsalesbycompanyandbranch/${companyId}/${branchId}`
        );

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        console.log('Fetched Sales Data:', data);
        setSalesData(data);
      } catch (err) {
        console.error('Error fetching sales data:', err);
        setError('Failed to load sales data.');
      } finally {
        setLoading(false);
      }
    };

    fetchSalesData();
  }, []);

  return (
    <XGolifeDashboardComponent>
      <Container className="mt-4">
        <h2 className="text-center mb-4" style={{ fontWeight: '600', color: '#000' }}>
          Sales by Branch
        </h2>

        {loading ? (
          <div className="text-center">
            <Spinner animation="border" variant="warning" />
          </div>
        ) : error ? (
          <Alert variant="danger" className="text-center">
            {error}
          </Alert>
        ) : salesData.length === 0 ? (
          <div className="text-center">
            <img
              src={emptyImage}
              alt="No sales found"
              style={{ maxWidth: '300px', width: '100%', marginBottom: '1rem', marginTop: 70}}
            />
            <p className="text-muted" style={{ fontSize: '18px' }}>
              No sales have been recorded yet.
            </p>
          </div>
        ) : (
          <div className="table-responsive shadow rounded">
            <Table bordered hover>
              <thead className="table-warning">
                <tr className="text-dark text-center">
                  <th><FaCalendarAlt /> Date</th>
                  <th><FaClock /> Shift</th>
                  <th><FaStore /> Branch</th>
                  <th><FaBoxes /> Product</th>
                  <th>Qty</th>
                  <th><FaDollarSign /> Selling Price</th>
                  <th><FaMoneyBillWave /> Amount Received</th>
                  <th>Payment Mode</th>
                  <th><FaUser /> Username</th>
                </tr>
              </thead>
              <tbody>
                {salesData.map((sale, index) => (
                  <tr key={index} className="text-center">
                    <td>{new Date(sale.sale_date).toLocaleDateString()}</td>
                    <td>{sale.shift_name}</td>
                    <td>{sale.branch_name}</td>
                    <td>{sale.product_name}</td>
                    <td>{sale.quantity}</td>
                    <td>${parseFloat(sale.selling_price).toFixed(2)}</td>
                    <td>${parseFloat(sale.amntrec).toFixed(2)}</td>
                    <td>{sale.pmode}</td>
                    <td>{sale.username}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Container>
    </XGolifeDashboardComponent>
  );
};

export default SalesByBranch;
